import { moduleProviderFactory } from "core/providers";
import { OngoingMissingInventoryEmailEdit } from "application/ongoing-missing-inventory/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.ongoing-missing-inventory.edit-email",
                        pattern: "/:facilityOrderId/ongoing-missing-inventory",
                        component: OngoingMissingInventoryEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "Ongoing Missing Inventory",
                                    route: 'master.app.main.facility-order.ongoing-missing-inventory.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB_DAVID",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.list",
						order: 1,
					}  
				]
			},
        ]
    });
})();
